import SportsShowcase from '@/components/SportsShowcase';
import Footer from '@/components/Footer';

export default function FeaturesPage() {
  return (
    <div className="pt-20">
      <SportsShowcase />
      <Footer />
    </div>
  );
}
